import { ChangeEvent, Dispatch, FC, Fragment, useEffect, useRef, useState } from "react";
import {
  Box, Chip, FormControl, FormControlLabel, FormGroup, Grid, InputLabel, MenuItem, Select, Switch, TextField,
  Typography
} from "@mui/material";
import { useStyles } from './styles';
import { LoadingButton } from "@mui/lab";
import PersonAddIcon from '@mui/icons-material/PersonAdd';
import BorderColorIcon from '@mui/icons-material/BorderColor';
import { DataRef } from "../../types/DataRef";
import { AlertType } from "../../types/AlertType";
import UserInformation from "../../types/UserInformation";
import { idProfilToAccessCommissionCommercialGRC, profilToAccessToAllFonctionnality } from "../../constants/Constants";
import { DataProfil } from "../../types/DataTypes";
import Cookies from "universal-cookie";
import axios, { AxiosInstance } from "axios";
import { DataUtilisateur } from "../content/parametrage/user/Tabs/utilisateur/Utilisateur";
import { DeviseInterface } from "../content/parametrage/Article/InterfaceArticle";
import CheckAttr from "../../utils/CheckAttr";

interface UserToCreate {
  id?: number;
  name: string;
  prenom: string;
  email: string;
  pays?: number[];
  Departement?: string;
  profil_user_id: number[];
  devise_id?: number;
  isLocked: boolean;
}

interface InputValidation {
  name: boolean;
  prenom: boolean;
  email: boolean;
  pays: boolean;
}

interface UserFormProps {
  onClose: () => void;
  dataPays: DataRef[];
  dataProfils: DataProfil[];
  utilisateur?: DataUtilisateur;
  setOpenSnack: Dispatch<React.SetStateAction<boolean>>;
  setAlerteMessage: Dispatch<React.SetStateAction<string>>;
  setAlertType: Dispatch<React.SetStateAction<AlertType>>;
  reloadList: () => void;
  // handleRefreshUsersDatas: (user: UserInformation, action: ActionType) => void;
}

const resetUserToCreate: UserToCreate = {
  name: '',
  prenom: '',
  email: '',
  pays: [],
  Departement: '',
  profil_user_id: [],
  isLocked: false
}

const resetInpuValidation: InputValidation = {
  name: false,
  prenom: false,
  email: false,
  pays: false
}

const urlBaseApi = process.env.REACT_APP_BASE_API_URL as string;

const UserForm: FC<UserFormProps> = ({
  dataPays,
  dataProfils,
  utilisateur,
  onClose,
  setOpenSnack,
  setAlerteMessage,
  setAlertType,
  reloadList
  // handleRefreshUsersDatas
}) => {
  const classes = useStyles();

  const [initializedUserId, setInitializedUserId] = useState<number | null>(null);

  const [isClickSave, setIsClickSave] = useState<boolean>(false);
  const [openSelectMultiple, setOpenSelectMultiple] = useState<boolean>(false);
  const [openSelectMultiple2, setOpenSelectMultiple2] = useState<boolean>(false);

  const [userToSave, setUserToSave] = useState<UserToCreate>(resetUserToCreate);
  const [errorInput, setErrorInput] = useState<InputValidation>(resetInpuValidation);

  const [deviseSelectedId, setDeviseSelectedId] = useState<number | string | undefined>(utilisateur?.devise_id);
  const [allDevise, setAllDevise] = useState<DeviseInterface[]>([]);

  const cookies = new Cookies();
  const token: string = cookies.get("jwt");

  const http: AxiosInstance = axios.create({
    baseURL: urlBaseApi,
    headers: {
      Authorization: `Bearer ${token}`,
    },
  });

  /* useEffect(() => {
    // 1️⃣ Initialisation du formulaire (UNE SEULE FOIS)
    if (utilisateur?.id && !isInitializedRef.current) {
      isInitializedRef.current = true;

      setUserToSave({
        id: utilisateur.id,
        name: utilisateur.name,
        prenom: utilisateur.prenom,
        email: utilisateur.email,
        pays: utilisateur.pays.map(p => p.id),
        Departement: utilisateur.Departement,
        profil_user_id: utilisateur.profils.map(x => x.id),
        devise_id: utilisateur.devise_id,
        isLocked: utilisateur.actif === "Non" || utilisateur.failed_attempts >= 5,
      });
    }

    // 2️⃣ Chargement des devises
    http
      .get("getalldevise")
      .then(res => {
        Array.isArray(res.data) && setAllDevise(res.data);
      })
      .catch(console.log);

  }, [utilisateur]); */

  useEffect(() => {
    // 2️⃣ Chargement des devises
    http.get("getalldevise").then(res => {
      Array.isArray(res.data) && setAllDevise(res.data);
    }).catch(console.log);
  }, []);

  useEffect(() => {
    if (!utilisateur?.id) return;

    // 🔒 Initialisation UNIQUE par utilisateur
    if (initializedUserId !== utilisateur.id) {
      setInitializedUserId(utilisateur.id);

      setUserToSave({
        id: utilisateur.id,
        name: utilisateur.name,
        prenom: utilisateur.prenom,
        email: utilisateur.email,
        pays: utilisateur.pays.map(p => p.id),
        Departement: utilisateur.Departement,
        profil_user_id: utilisateur.profils.map(x => x.id),
        devise_id: utilisateur.devise_id,
        isLocked: utilisateur.actif === "Non" || utilisateur.failed_attempts >= 5,
      });
    }
  }, [utilisateur, initializedUserId]);

  useEffect(() => {
    //console.log("isLocked =", userToSave.isLocked);
    console.log("");
  }, [userToSave.isLocked]);

  const handleChange = (e: any) => {
    const { name, value } = e.target;

    setUserToSave({
      ...userToSave,
      [name]: value
    })
  };

  const handleToggleLock = (e: ChangeEvent<HTMLInputElement>) => {
    setUserToSave((prev) => ({
      ...prev,
      isLocked: e.target.checked,
    }));
  };

  const containsValues = (array1: number[], array2: number[]): boolean => {
    // Créer un ensemble à partir du premier tableau pour une recherche plus rapide
    const set1 = new Set(array1);

    // Vérifier si chaque élément du deuxième tableau est présent dans l'ensemble
    return array2.some(value => set1.has(value));
  }

  const isValidate = (): boolean => {
    // Reinitialise les variables des validations
    setErrorInput(resetInpuValidation);

    if (
      userToSave?.name?.length === 0 ||
      userToSave?.prenom?.length === 0 ||
      userToSave?.email?.length === 0 ||
      userToSave?.pays?.length === 0) {
      if (userToSave?.name?.length === 0) {
        setErrorInput((prev: InputValidation) => ({ ...prev, name: true }));
      }

      if (userToSave?.prenom?.length === 0) {
        setErrorInput((prev: InputValidation) => ({ ...prev, prenom: true }));
      }

      if (userToSave?.email?.length === 0) {
        setErrorInput((prev: InputValidation) => ({ ...prev, email: true }));
      }

      if (userToSave?.pays?.length === 0) {
        setErrorInput((prev: InputValidation) => ({ ...prev, pays: true }));
      }

      setAlerteMessage("Merci de remplir les champs en rouge !");
      setAlertType("warning");
      setOpenSnack(true);

      return false;
    }
    return true;
  }

  const handleCreateUser = async () => {
    await http.post('user/register', userToSave)
      .then(res => {
        reloadList();
        setAlerteMessage("Enregistrement efféctuée !");
        setAlertType("success");
        setOpenSnack(true);
        onClose();
      }).catch(error => {
        console.log(error);
        setAlertType("error");
        setOpenSnack(true);
      }).finally(() => {
        setIsClickSave(false);
      });
  };

  const handleUpdateUser = async () => {
    await http.put(`user/edit/${utilisateur?.id}`, userToSave)
      .then(res => {
        reloadList();
        setAlerteMessage("Enregistrement efféctuée !");
        setAlertType("success");
        setOpenSnack(true);
        onClose();
      }).catch(error => {
        console.log(error);
        setAlertType("error");
        setOpenSnack(true);
      }).finally(() => {
        setIsClickSave(false);
      });
  };

  const handleSave = () => {
    if (isValidate()) {
      setIsClickSave(true);

      if (utilisateur?.id) {
        /**
         * Cas mis à jour
         */
        handleUpdateUser();
      } else {
        /**
         * On verifie d'abord si l'email existe déja dans la base
         */
        http.post('user/check-existance', userToSave)
          .then(res => {
            const { exist } = res.data;

            if (!exist) {
              // Si l'email n'est pas encore utilisé, alors on passe à la création
              handleCreateUser();
            } else {
              // Si l'email existe déja, alors on bloque le process et on alerte l'utilisateur
              setAlerteMessage("Désolé! L'email saisi existe déjà !");
              setAlertType("warning");
              setOpenSnack(true);
              setIsClickSave(false);
            }
          }).catch(error => {
            console.log(error);
            setAlertType("error");
            setOpenSnack(true);
            setIsClickSave(false);
          });
      }
    }
  };

  const handleCloseSelectMulti = () => {
    setOpenSelectMultiple((prev) => !prev);
  };

  const handleCloseSelectMulti2 = () => {
    setOpenSelectMultiple2((prev) => !prev);
  };

  const handleChangeSelectMultitple = (e: any) => {
    e.stopPropagation();
    handleCloseSelectMulti();
    setUserToSave((prev) => ({
      ...prev,
      pays: e.target.value,
    }));
  };

  const handleChangeSelectMultitple2 = (e: any) => {
    e.stopPropagation();
    handleCloseSelectMulti2();
    setUserToSave((prev) => ({
      ...prev,
      profil_user_id: e.target.value,
    }));
  };

  let isSuperAdminUser = false;
  let profils: DataProfil[] = dataProfils;
  if (utilisateur?.profils) {
    if (utilisateur?.profils?.filter(p => profilToAccessToAllFonctionnality.includes(p.libelle))) {
      isSuperAdminUser = true;
    }

    if (dataProfils?.length && !isSuperAdminUser) {
      profils = dataProfils?.filter(p => !profilToAccessToAllFonctionnality.includes(p?.libelle));
    }
  }

  return (
    <Fragment>
      <Box className={classes.root}>
        <Grid container spacing={2} columns={{ xs: 6, sm: 12, md: 4 }}>
          <Grid item xs={6} sm={6} md={2}>
            <TextField
              name="name"
              label="Nom"
              color="warning"
              // size="small"
              autoComplete="off"
              value={userToSave?.name}
              error={errorInput?.name}
              onChange={handleChange}
              variant="outlined"
              InputLabelProps={{ shrink: true }}
            />
            <TextField
              name="prenom"
              label="Prénom"
              color="warning"
              // size="small"
              autoComplete="off"
              value={userToSave?.prenom}
              error={errorInput?.prenom}
              onChange={handleChange}
              variant="outlined"
              InputLabelProps={{ shrink: true }}
            />
          </Grid>
          <Grid item xs={6} sm={6} md={2}>
            <TextField
              name="email"
              label="Email"
              color="warning"
              disabled={utilisateur?.updated_password}
              autoComplete="off"
              value={userToSave?.email}
              error={errorInput?.email}
              onChange={handleChange}
              variant="outlined"
              InputLabelProps={{ shrink: true }}
            />
            <TextField
              name="Departement"
              label="Departement"
              color="warning"
              // size="small"
              autoComplete="off"
              value={userToSave?.Departement}
              onChange={handleChange}
              variant="outlined"
              InputLabelProps={{ shrink: true }}
            />
          </Grid>
        </Grid>

        <Grid container spacing={2} columns={{ xs: 6, sm: 12, md: 4 }}>
          <Grid item xs={6} sm={6} md={2}>
            <FormControl variant="outlined" className={classes.formControl}>
              <InputLabel htmlFor="profil-contact" color="warning" shrink={true}>
                Pays
              </InputLabel>
              <Select
                open={openSelectMultiple}
                onClick={() => handleCloseSelectMulti()}
                multiple
                error={errorInput.pays}
                displayEmpty
                value={userToSave?.pays}
                onChange={handleChangeSelectMultitple}
                renderValue={(selected) => {
                  return (
                    <div className={classes.chips}>
                      {((selected as number[]) || []).map((value) => (
                        <Chip
                          key={value}
                          label={dataPays.find(item => item.id === value)?.libelle}
                          className={classes.chip}
                        />
                      ))}
                    </div>
                  );
                }}
                label="Pays"
                color="warning"
                inputProps={{
                  name: 'pays',
                  id: 'pays',
                }}
                MenuProps={{
                  sx: {
                    "&& .Mui-selected": {
                      backgroundColor: "#080d24",
                      color: "#fff"
                    }
                  }
                }}
              >
                <MenuItem disabled value="" dense></MenuItem>
                {dataPays.map(pays => (
                  <MenuItem
                    key={pays.id}
                    value={pays.id}
                    onClick={() => handleCloseSelectMulti()}
                    dense
                  >
                    {pays.libelle}
                  </MenuItem>
                ))}
              </Select>
            </FormControl>
          </Grid>
          <Grid item xs={6} sm={6} md={2}>
            <FormControl variant="outlined" className={classes.formControl}>
              <InputLabel htmlFor="profil-contact" color="warning" shrink={true}>
                Profil utilisateur
              </InputLabel>
              <Select
                open={openSelectMultiple2}
                onClick={() => handleCloseSelectMulti2()}
                multiple
                displayEmpty
                value={userToSave?.profil_user_id}
                onChange={handleChangeSelectMultitple2}
                renderValue={(selected) => {
                  return (
                    <div className={classes.chips}>
                      {((selected as number[]) || []).map((value) => (
                        <Chip
                          key={value}
                          label={profils.find(item => item.id === value)?.libelle}
                          className={classes.chip}
                        />
                      ))}
                    </div>
                  );
                }}
                label="Profil utilisateur"
                color="warning"
                inputProps={{
                  name: 'profil_user_id',
                  id: 'profil_user_id',
                }}
                MenuProps={{
                  sx: {
                    "&& .Mui-selected": {
                      backgroundColor: "#080d24",
                      color: "#fff"
                    }
                  }
                }}
              >
                <MenuItem disabled value="" dense></MenuItem>
                {profils.map(profil => (
                  <MenuItem
                    key={profil.id}
                    value={profil.id}
                    onClick={() => handleCloseSelectMulti2()}
                    dense
                  >
                    {profil.libelle}
                  </MenuItem>
                ))}
              </Select>
            </FormControl>
          </Grid>
          {
            containsValues(userToSave?.profil_user_id, idProfilToAccessCommissionCommercialGRC) && (
              <Grid item xs={6} sm={6} md={2}>
                <FormControl
                  variant="outlined"
                  className={classes.formControl}
                  sx={{ marginLeft: 1, marginTop: 1 }}
                >
                  <InputLabel
                    htmlFor="operation"
                    color="warning"
                    shrink={CheckAttr(userToSave?.devise_id)}
                  >
                    Devise De Commission
                  </InputLabel>
                  <Select
                    id="activite"
                    native
                    color="warning"
                    name="devise_id"
                    // error={errorInput.deviseSelected}
                    //value={deviseSelectedId}
                    /*onChange={(e) =>
                      setDeviseSelectedId(
                          e.target.value
                      )
                    }*/
                    value={userToSave?.devise_id}
                    onChange={handleChange}
                    label="devise_id"
                    inputProps={{
                      name: "devise_id",
                    }}
                  >
                    <option value=""></option>
                    {allDevise?.map((devise) => (
                      <option key={devise?.id} value={devise?.id}>
                        {devise?.code_iso}
                      </option>
                    ))}
                  </Select>
                </FormControl>
              </Grid>
            )
          }
        </Grid>

        <Grid container spacing={2} columns={{ xs: 6, sm: 12, md: 12 }}>
          <Grid item xs={6} sm={12} md={12}>
            <FormControlLabel
              control={
                <Switch
                  checked={userToSave.isLocked}
                  onChange={handleToggleLock}
                  color={userToSave.isLocked ? "error" : "success"}
                />
              }
              label={
                <Typography
                  sx={{
                    fontWeight: 500,
                    color: userToSave.isLocked ? "error.main" : "success.main",
                    transition: "color 0.2s ease"
                  }}
                >
                  {userToSave.isLocked
                    ? "Compte verrouillé 🔒"
                    : "Compte actif 🔓"}
                </Typography>
              }
              sx={{ my: 2 }}
            />
          </Grid>
        </Grid>

        <Box display="flex" justifyContent="center">
          <LoadingButton
            onClick={() => handleSave()}
            endIcon={utilisateur?.id ? <BorderColorIcon /> : <PersonAddIcon />}
            loading={isClickSave}
            loadingPosition="end"
            sx={{ textTransform: "none" }}
            variant="contained"
            color="warning"
          >
            {utilisateur?.id ? "Enregistrer" : "Ajouter"}
          </LoadingButton>
        </Box>
      </Box >
    </Fragment>
  );
};

export default UserForm;